import React from 'react';
import { Flex, Typography, IconTrash } from '@banhala/ui-kit';
import { TouchableOpacity } from 'react-native';

type Props = {
  key: number;
  name: string;
  relation: string;
  mobile: string;
  onDelete: () => void;
};

export const PocRow: React.FC<Props> = ({
  name,
  relation,
  mobile,
  onDelete,
}) => {
  return (
    <Flex padding={{ top: 24 }}>
      <Flex.Row
        justifyContent={'space-between'}
        alignItems={'center'}
        padding={{ vertical: 12, horizontal: 16 }}
      >
        <Flex.Column gap={8}>
          <Typography type="subtitle1" color="content_primary">
            {name}, {relation}
          </Typography>
          <Typography type="body2" color="content_tertiary">
            {mobile}
          </Typography>
        </Flex.Column>
        <TouchableOpacity onPress={onDelete}>
          <Flex.Center
            width={30}
            height={30}
            borderRadius={15}
            borderWidth={0.5}
            borderColorValue={'red'}
          >
            <IconTrash size={16} fill="red" />
          </Flex.Center>
        </TouchableOpacity>
      </Flex.Row>
    </Flex>
  );
};
